<template>
  <section class="container">
    <!-- plus_id  {{plus_id}} <br>
    state  {{state}} <br>
    req  {{req}} <br>
    data  {{data}} <br> -->
  </section>
</template>

<script>
import Const from '../helpers/Const.js'
export default {
  data() {
    return {
      // plus_id:'X',
      // state:'X',
      // req:'X',
      // data:'X',
    }
  },
  created() {
    this.onload = false;
    this.chkSuccess();
  },

  methods: {
    chkSuccess() {
      var query = this.$route.query;

      var msg = '잘못된 접근경로 입니다. 메인 화면으로 이동합니다.';
      var route = '/'; //가입 화면
      var data = (typeof query.reqs != 'undefined') ? JSON.parse(decodeURI(query.reqs)) : null;


      // if(typeof query.plus_id != 'undefined') this.plus_id = query.plus_id
      // if(typeof query.state != 'undefined') this.state = query.state
      // if(typeof query.reqs != 'undefined') this.req = query.reqs
      // if(typeof query.reqs != 'undefined') this.data = data


      // plus_id 있다. 
      if(typeof query.vtg_id != 'undefined') {

        //가입 결과 상태 있다.
        if(typeof query.state != 'undefined')
        {

          data.user.id = this.$store.state.user.id;

          if(data) this.$store.commit('setSubsc', data);

          let step = Number(data.subsc.payments.step)|| 0;

          //가입 성공
          if(query.state == Const.STATE.NORMAL) {
            if(data){ 
              msg = null;
              route = `/subscApply/res?step=${step + 1}`;//가입완료 화면
            } else {
              msg = '가입이 완료 되었으나 오류가 발생하였습니다. 관리자에 문의해주세요.';  
            }

          }
          //가입 실패
          else if(query.state == Const.STATE.ABNORMAL){
            msg = query.msg;
            if(data) route = `/subscApply/req?step=${step}`;//가입결제 화면
          }

        }

        if(msg) alert(msg);
        this.onload = true;

        return this.$router.push(route);

      } 
      alert('잘못된 접근경로 입니다. 메인 화면으로 이동합니다.');
      // plus_id 없다. go oas
      this.onload = true;
      //location.href = this.$store.state.host.plus;
      location.href = this.$store.state.host.vtg;
  
    }
  }

};
</script>